import React, {useRef, useState} from "react";
import Portal from "../portal";
import {Form} from "react-final-form";
import {Button} from "../My/Button";
import {FiSend} from "react-icons/fi";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {CLOSE_WELCOME_MODAL, SET_ACCEPT_TERMS} from "../../reducers/user";

const WelcomeModal = ({}) => {

    const {user} = useSelector((state) => state);

    const dispatch = useDispatch();
    const {palettes} = useSelector(
        (state) => ({
            palettes: state.palettes,
        }),
        shallowEqual
    )

    let {background} = {
        ...palettes
    }

    const modalRef = useRef(null)

    const send = (values) => {
        dispatch({type:CLOSE_WELCOME_MODAL, payload:true})
    }

    if(user.welcomeModal) {


        return (
            <Portal selector="#portal">
                <div className="modal-backdrop fade-in bg-blue-500"></div>
                <div className={`modal show ${background === 'dark' ? 'dark-mode' : ''}`}
                     data-background={background}>
                    <div className="relative min-w-sm w-1/2 mx-auto lg:max-w-5xl bg-white rounded" ref={modalRef}>
                        <div className="modal-content">
                            <Form onSubmit={send} render={({handleSubmit}) => (
                                <div className={"w-full"}>
                                    <div className={"m-5 text-lg flex flex-col text-center content-center "}>
                                        <span className={"font-bold underline"}>Vítejte v&nbsp;našem registračním systému!</span>
                                        <span className={"my-3"}>Slavnost a výstava se koná od&nbsp;29.5.2026&nbsp;do&nbsp;31.5.2026 na&nbsp;Výstavišti Praha&nbsp;-&nbsp;Holešovice</span>
                                    </div>
                                    <div className={"m-5 text-lg flex flex-col"}>
                                        <span className={"font-bold mb-5"}>Co Vás čeká bude-li Váš vůz schválen komisí:</span>
                                        <ul className="ml-8" style={{ listStyleType: 'none' }}>
                                            {[
                                                { title: "Skvělá společnost", text: "Stanete se součástí jedinečné akce, která je největší v ČR!" },
                                                { title: "Komunita a smyluplný společenský přínos", text: "Stanete se součástí komunity, která sdílí vášeň pro krásnou techniku a rozšiřuje povědomí o automobilové kultuře. Navíc přinesete radost návštěvníkům." },
                                                { title: "Exkluzivní vstup zdarma", text: "Každý vybraný majitel exponátu a jeho doprovod získává dva celodenní třídenní vstupy v celkové hodnotě 4.000 Kč." },
                                                { title: "Občerstvení", text: "Každý majitel vozu obdrží poukázky na vodu, limonádu a pivo." },
                                                { title: "Pamětní předměty", text: "Připravujeme pro vás novou sadu zajímavých a hodnotných produktů od slavnosti LEGENDY." }
                                            ].map((item, index) => (
                                                <li key={index} style={{ position: 'relative', marginBottom: '10px', paddingLeft: '5px' }}>
                                                    <span style={{ position: 'absolute', left: '-25px' }}>👉</span>
                                                    <b>{item.title}: </b>{item.text}
                                                </li>
                                            ))}
                                        </ul>
                                        <span className={"text-center center-center mt-5 font-bold"}>Těšíme se na viděnou!</span>
                                    </div>

                                    <div className="modal-footer space-x-2">
                                        <Button onClick={handleSubmit}
                                                text={"Pokračovat"} icon={<FiSend/>}/>
                                    </div>
                                </div>
                            )}/>
                        </div>
                    </div>
                </div>
            </Portal>
        )
    }else{
        return <></>
    }
}
export default WelcomeModal;
